import { inject, Injector } from '@angular/core';

import { ForbiddenError, HttpError, UnauthorizedError } from 'src/app/core/services/api/errors';
import { ToastrService } from 'ngx-toastr';
import type { ErrorHandlerOptions } from '@sentry/angular';
import { SentryErrorHandler } from '@sentry/angular';

/**
 * Global error handler.
 */
export class AppErrorHandler extends SentryErrorHandler {
  #injector = inject(Injector);
  #toastrService?: ToastrService;

  override handleError(error: unknown): void {
    // ErrorInterceptor 経由のエラーの場合は error.rejection にエラーオブジェクトが入っている
    super.handleError(error);
    // 遅延して ToastrService を取得
    if (!this.#toastrService) {
      this.#toastrService = this.#injector.get(ToastrService);
    }
    if (error instanceof UnauthorizedError) {
      // UnauthorizedError の場合はログインページに遷移する
      window.location.href = `/login?returnUrl=${encodeURIComponent(error.returnUrl)}`;
    } else if (error instanceof ForbiddenError) {
      // ログイン画面への誘導
      this.#toastrService.info(error.message);
    } else if (error instanceof HttpError) {
      // コンポーネントでハンドルされなかったHttpErrorのラーメッセージを表示する
      this.#toastrService.error(error.message);
    } else if (!(error instanceof HttpError)) {
      // HttpErrorでない場合はブラウザがコンソールにエラーを出力するので除外する
      console.error(error);
      // Sentry にエラーを通知する
      super.handleError(error);
    } else {
      // その他のエラーはコンソールに出力する
      console.error(error);
      // Sentry にエラーを通知する
      super.handleError(error);
    }
  }
}

/**
 * Factory function that creates an instance of a preconfigured ErrorHandler provider.
 */
function createErrorHandler(config?: ErrorHandlerOptions): AppErrorHandler {
  return new AppErrorHandler(config);
}

export { createErrorHandler };
